import * as moment from 'moment';
import {concat, isEmpty, min, remove, sumBy, capitalize} from 'lodash';
import {PortfolioType} from '../model/portfolio-type.model';

export class PortfolioUtil {
    public static aggregatePortfoliosByType(allPortfolios: any[], portfolioType: PortfolioType): void {
        const portfoliosByType = remove(allPortfolios, (portfolio: any) => portfolio.portfolio_type === portfolioType);
        if (isEmpty(portfoliosByType) || isEmpty(portfolioType)) {
            return;
        }
        const allLoanDetails = portfoliosByType.map((portfolio: any) => portfolio.loan_details);
        const allClosedLoanDetails = portfoliosByType.map((portfolio: any) => portfolio.closed_loan_details);
        let aggregatedLoanDetails = [];
        let aggregatedClosedLoanDetails = [];
        allLoanDetails.forEach(details => aggregatedLoanDetails = concat(aggregatedLoanDetails, details));
        allClosedLoanDetails.forEach(details => aggregatedClosedLoanDetails = concat(aggregatedClosedLoanDetails, details));
        const aggregatedPortfolio = {
            _id: portfoliosByType[0]._id,
            portfolio_type: portfolioType,
            portfolio_name: capitalize(portfolioType),
            investment_amt: sumBy(portfoliosByType, (portfolio: any) => portfolio.investment_amt),
            remaining_amt: sumBy(portfoliosByType, (portfolio: any) => portfolio.remaining_amt),
            loan_details: aggregatedLoanDetails,
            closed_loan_details: aggregatedClosedLoanDetails,
            createdAt: min(portfoliosByType.map((portfolio: any) => moment(portfolio.createdAt).toDate()))
        };

        allPortfolios.push(aggregatedPortfolio);
    }

    public static removeCancelledPortfolios(portfolios: any[]) {
        remove(portfolios, portfolio => portfolio.status === 'cancelled');
    }
}
